import {
  SelectOption,
  useFormContext,
  useWatch,
} from '@kanda-libs/ks-component-ts';
import { useEffect, useMemo } from 'react';
import { formatToCurrency } from 'utils';
import { EnquiryProjectBudgetFormValues } from '../useEnquiryProjectBudgetForm';
import { BUDGET_STEP, MAX_BUDGET, MIN_BUDGET } from './constants';

export interface EnquiryProjectBudgetFormFieldsHook {
  options: SelectOption[];
}

export default function useEnquiryProjectBudgetFormFields(): EnquiryProjectBudgetFormFieldsHook {
  const { setValue } = useFormContext<EnquiryProjectBudgetFormValues>();
  const budget = useWatch<EnquiryProjectBudgetFormValues, 'budget'>({
    name: 'budget',
  });

  const budgets = useMemo(() => {
    const numSteps = Math.ceil((MAX_BUDGET - MIN_BUDGET) / BUDGET_STEP);
    return Array.from(Array(numSteps).keys()).map((index: number) => {
      const min = MIN_BUDGET + index * BUDGET_STEP;
      const max = min + BUDGET_STEP;
      if (max > MAX_BUDGET)
        return {
          min,
          max: MAX_BUDGET,
        };
      return {
        min,
        max,
      };
    });
  }, []);

  const options = useMemo(
    () =>
      budgets.map((current) => ({
        name: `${formatToCurrency(current.min)} - ${formatToCurrency(
          current.max,
        )}`.replace(/\.00/g, ''),
        value: `${current.min}-${current.max}`,
      })),
    [budgets],
  );

  useEffect(() => {
    if (!budget) return;
    const [min, max] = budget.split('-');
    setValue('budgets.min.amount', parseInt(min, 10));
    setValue('budgets.max.amount', parseInt(max, 10));
  }, [budget, setValue]);

  return {
    options,
  };
}
